<template>

   <spinner v-if="!loaded" ></spinner>

    <div class="template-padding container" v-else-if="loaded"  > 
        
        <div class="row" >
            <div class="col-12 text-left" >
                <router-link :to="{name: 'Business Accelerator' }" class="not-active text-left btn btn-transparent border-none btn-sm" > 
                    <font-awesome-icon icon="arrow-circle-left" ></font-awesome-icon> Back 
                </router-link>
            </div>
        </div>
        
        <div class="col-12 col-md-10 offset-md-1 p-0 mt-3" >
            <img src="@/assets/images/business_accelerator_1200x628-01.png" class="w-100" />
        </div>
        
        <div class="text-justify mt-5 mb-3 h4" style="line-height: 1.5;" >

        </div>
        
        <!-- ACADEMY -->
        <div class="accordion mt-5" role="tablist">
            
            <!-- INTRO -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-0 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Introduction
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion0" > {{ calculateRead('accordion0') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-0"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion0" >
                        
                        Oftentimes overlooked, understanding the key data points can be the difference between a struggling and a thriving online business. In order to understand these metrics, we first need to talk about tracking.
                        <br><br>
                        Tracking is the most important part of running an online business successfully. Unfortunately, many people don’t realize how important tracking is. 
                        <br><br>
                        Just like Geoffrey Moore said, 
                        <h3 class="text-left font-weight-bold mt-5 mb-2" > “Without big data, you are blind and deaf and in the middle of a freeway.” </h3>
                        <br>
                        Tracking allows you to monitor and analyze key aspects of the business in order to improve them. Running an online business is a constant optimization process, you need to test multiple variations of each element until you find a winner.
                        <br><br>
                        The first part of the monetization process is to have tracking set up. 
                        <br><br>
                        Once you have that, we can start looking at these key metrics. There are a lot of metrics you need to look at when running a business, however, we cannot cover all of them right now. For start, let’s look at a couple of metrics, spread over 2 different sets of data points: metrics for your funnel and metrics for your ads.
                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- INTRO -->
            
            <!-- Structure -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-1 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        AD level metrics
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion1" > {{ calculateRead('accordion1') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-1"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion1">
                        
                        <h4 class="text-left font-weight-bold mb-2" >CPC - Cost Per Click </h4>
                        This shows how much you pay for every click on the ad and it’s calculated by dividing the total money spent on ads by the number of clicks.
                        <br><br>
                        Standard and Goals: between $0.5- $4
                        <h4 class="text-left font-weight-bold mt-5 mb-2" >CTR - Click Through Rate </h4>
                        This shows what % of people are clicking through the ad to get to the sales page.
                        <br><br>
                        Standard and Goals: between 2-5%
                        <h4 class="text-left font-weight-bold mt-5 mb-2" >CPL - Cost Per Lead </h4>
                        This shows you how much every lead that opts-in costs you.
                        <h4 class="text-left font-weight-bold mt-5 mb-2" >CVR - Conversion Rate </h4>
                        This shows what % of people bought the product or service you are offering
                        <br><br>
                        Standard and Goals: between 2-5%
                        <h4 class="text-left font-weight-bold mt-5 mb-2" >CPA - Cost Per Acquisition ( Cost Per Sale ) </h4>
                        This shows how much it costs you to get a sale and it’s calculated by dividing the total money spent on ads by the number of sales.
                        <h4 class="text-left font-weight-bold mt-5 mb-2" >CV - Conversion Value </h4>
                        This shows the amount of revenue that was generated.
                        <h4 class="text-left font-weight-bold mt-5 mb-2" >ROAS - Return On Ad Spend </h4>
                        This shows how much you get back after spending on ads and tell you if the ads are profitable or not.
                        
                        <h4 class="text-left font-weight-bold mt-5 mb-2" >Example</h4>
                        Say you are paying $50 for an ad and that ad has 1000 impressions, meaning 1000 people saw it. Out of 1000 people, 50 clicked your ad. 
                        <br><br>
                        This means you have  a CTR of 5%.
                        <br><br>
                        If your total spend was $50 and you’ve got 50 clicks, that means your CPC is $1.
                        <br><br>
                        Now, if out of those 50 people, 10 people opt in and 5 of them bought your product, you’ve got a CVR of 10%. Based on that, we can easily calculate the CPA is $10 ( $50/5) as well as the CPL, which is $5 ( $50/10 leads ).
                        <br><br>
                        Now, let’s look at the value of those sales. Say for example, your offer is $50 for every product or service bought.
                        So your Total Conversion Value is $250, 5 sales of $50 each. Based on that, we can easily calculate the ROAS: $200. 
                        <br><br>Cause you spent $50 to get $200, which is a pretty good investment.
                        <br><br>
                        Now this is a simple example, to better understand these metrics. In real life, it’s not gonna be that pretty.
                        <br><br>
                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Structure -->
            
            <!-- Structure -->
            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-2" role="tab">
                    <div block v-b-toggle.accordion-2 class="col-12 cursor-pointer font-size-20 font-weight-bold" >
                        Funnel level metrics
                        <div class="float-right graymedium-color h6 mt-3 ml-2" > 
                            <span id="accordion2" > {{ calculateRead('accordion2') }} </span>
                            <font-awesome-icon :icon="['fas', 'glasses']" class="" style="margin-top: -3px;" /> 
                        </div>
                    </div>
                </b-card-header>
                <b-collapse id="accordion-2"  accordion="my-accordion" role="tabpanel" class="p-3" >
                    <b-card-body ref="accordion2" >
                                                
                        <h4 class="text-left font-weight-bold mb-2" >Clicks</h4>
                        This shows what number of people that landed on your funnel or page.
                        <h4 class="text-left font-weight-bold mt-5 mb-2" >CVR -  Conversion Rate</h4>
                        This is the biggest metric of the funnel, it shows what % of people have converted ( purchased a product, opt-ed in, signed up, whatever the goal is ).
                        Standard and Goals: between 2-5%
                        <h4 class="text-left font-weight-bold mt-5 mb-2" >Speed load</h4>
                        This shows how much it takes for your page to load and it needs to be tested for both desktop and mobile, as mobile is usually slower.
                        Standard and Goals: between 4 - 6s
                        <h4 class="text-left font-weight-bold mt-5 mb-2" >Exit Rate</h4>
                        This shows what % of people quit on the cart page. About 90% of people quit there so this needs to be taken very seriously.
                        Standard and Goals: between 80% - 90%
                        <h4 class="text-left font-weight-bold mt-5 mb-2" >Upsell Take Rate</h4>
                        This shows the % of people that purchased your upsells, the products or services you sell for customers that recently bought.
                        Standard and Goals: between 20 - 30%
                        <h4 class="text-left font-weight-bold mt-5 mb-2" >AOV - Average Order Value </h4>
                        One of the most important metrics for scaling, it shows you on average per 100 people, how many buy the frontend product and the upsells.
                        Standard and Goals: 2x the frontend offer
                        <h4 class="text-left font-weight-bold mt-5 mb-4" >LTV - Lifetime Value</h4>
                        One of the most important metrics for scaling, is an estimate of the average revenue a customer will generate throughout their lifespan. This is a very important metric for scaling and running a successful business.
                        
                    </b-card-body>
                </b-collapse>
            </b-card>
            <!-- Structure -->
        
          </div>
        <!-- ACADEMY -->

        
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
    
export default{
    name: "ACADEMY_sales_page",
    props:["APPKEY"],
    components:{
    },
    data () {
        return {
            loaded: false,
            text: `
              Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
              richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
              brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
              tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
              assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
              wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
              vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
              synth nesciunt you probably haven't heard of them accusamus labore VHS.
            `
        }
    },
    mounted(){
        this.loaded = true;
    },
    methods:{
        openRow(params){
            
            let user =  Cookies.get('user')
            user = JSON.parse( atob( user ) )
            
            let page = params.row.Icon;
            let ID = params.row.ID;
            
            
            
            
        },
        returnDate(a){
            //return this.$moment.unix(a).format( 'MMM D, HH:mm' )
            return helper.formatDate( a, 'MMM D, HH:mm' )
        },
        
        calculateRead( target ){
            
            //console.log( ev )
            setTimeout( function(){
                
                //console.log( this.$refs )
                //console.log( this.$refs[target].innerHTML )                
                
                let ev = this.$refs[target].innerHTML
                
                const wordsPerMinute = 150; // Average case.
                let result;
                
                let textLength = ev.split(" ").length; // Split by words
                if(textLength > 0){
                    let value = Math.ceil(textLength / wordsPerMinute);
                    result = `~${value} min read`;
                }
                //return result
                //this.$refs[target].appendChild( result )
                document.getElementById(target).innerHTML = result;
                
            }.bind(this), 400 )
                
        }
    },
    computed: {

    },
    created: function () {

    },
    
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/templates/Academy/courses/business-accelerator/05.vue